'use client';
import { DateObject, type StepperRef, useCountdown } from '@capsicum/common';
import { useEffect, useState } from 'react';

export const CODE_VERIFICATION_LENGTH = 6;

export const useCodeVerification = (
	onResendPress: () => void,
	stepperRef: React.RefObject<StepperRef>,
	initialError: string | undefined,
	onCodeSubmit: (code: string) => void
) => {
	const [code, setCode] = useState('');
	const [error, setError] = useState(initialError);

	const reminderCountdown = useCountdown({
		immediate: true,
		minutes: 0,
		seconds: 60
	});

	const resendHandler = () => {
		onResendPress();
		setCode('');
		reminderCountdown.reset(new DateObject().getTime());
	};

	const goToFirstStep = () => stepperRef?.current?.moveToStepIndex(0);

	useEffect(() => {
		if (code.length === CODE_VERIFICATION_LENGTH) onCodeSubmit(code);

		if (error && code.length < CODE_VERIFICATION_LENGTH) {
			setError(undefined);
		}
	}, [code]);

	useEffect(() => {
		setError(initialError);
	}, [initialError]);

	return {
		code,
		error,
		goToFirstStep,
		reminderCountdown,
		resendHandler,
		setCode,
		setError
	};
};
